import { useApiQuery } from '@common/hooks';
import { BaseFeatureArgs, SkipOrArgs } from '@common/types/queryState';
import { useSelectedProductionId } from '@features/productions';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetMediaObjectInstanceQuery } from '../api';
import { GetClipMediaArgs } from '../types';
import { DEFAULT_MEDIA_IDENTIFIER } from '../types/media';
import { mergeWithDefault } from '@common/utils/mergeWithDefault';

export interface UseClipMediaResolverArgs extends BaseFeatureArgs {
    mediaObjectId: string;
    moiId: string;
}

export const useClipMediaResolver = (
    args: SkipOrArgs<UseClipMediaResolverArgs>,
) => {
    const productionId = useSelectedProductionId();

    const queryArgs: SkipOrArgs<GetClipMediaArgs> = useMemo(() => {
        if (
            args === skipToken ||
            !args.mediaObjectId ||
            !args.moiId ||
            !productionId
        )
            return skipToken;

        return {
            ...args,
            productionId,
        };
    }, [args, productionId]);

    const { data, ...queryResult } = useApiQuery(
        useGetMediaObjectInstanceQuery,
        queryArgs,
    );

    return {
        data: mergeWithDefault(data, DEFAULT_MEDIA_IDENTIFIER),
        ...queryResult,
    };
};
